namespace SP {
  export type anyObject = { [key: string]: anyObject | any };
  export function getObjectRefrence(obj: anyObject | any): string {
    if (typeof obj !== "object" || obj === null) return typeof obj;

    let objTypes: string[] = [];
    for (let k in obj) {
      if (obj.hasOwnProperty(k)) {
        let type = typeof obj[k];
        switch (type) {
          case "object":
            if (obj[k] === null) {
              objTypes.push(`${k}: null`);
            } else {
              let def = getObjectRefrence(obj[k]);
              objTypes.push(`${k}: ${def}`);
            }
            break;
          default:
            objTypes.push(`${k}: ${type}`);
        }
      }
    }

    return `{ ${objTypes.join(", ")} }`;
  }
}
